<template>
	<div :id="`spinner-${uuid}`"></div>
</template>

<script>
import { defineComponent } from 'vue';
import _ from 'lodash';
import { Spinner } from 'spin.js';

export default defineComponent({
	name: 'LoadingSpinner',
	props: {
		config: {
			type: Object,
			default: () => { }
		}
	},
	data() {
		return {
			uuid: Math.random().toString(16).substring(2)
		};
	},
	mounted() {
		// these options can be overwritten by config
		const opts = {
			lines: 12, // The number of lines to draw
			length: 16, // The length of each line
			width: 5, // The line thickness
			radius: 16, // The radius of the inner circle
			scale: 0.8, // Scales overall size of the spinner
			corners: 1, // Corner roundness (0..1)
			direction: 1, // 1: clockwise, -1: counterclockwise
			color: '#444444', // #rgb or #rrggbb or array of colors
			speed: 1.5, // Rounds per second
			trail: 80, // Afterglow percentage
			className: 'spinner' // The CSS class to assign to the spinner
		};

		// these options cannot be overwritten by config
		const fixed = {
			rotate: 0, // The rotation offset
			shadow: false, // Whether to render a shadow
			hwaccel: true, // Whether to use hardware acceleration
			zIndex: 2e9, // The z-index (defaults to 2000000000)
			top: '50%', // Top position relative to parent
			left: '50%' // Left position relative to parent
		};

		const options = _.assign({}, opts, this.config, fixed);
		const target = document.getElementById('spinner-'+this.uuid);
		new Spinner(options).spin(target);

		// TODO: Set var for instance and expose stop() method (call when fade transition is complete)
	}
});
</script>

<style>
@keyframes spinner-line-fade-more {
	0%,
	100% {
		opacity: 0; /* minimum opacity */
	}
	1% {
		opacity: 1;
	}
}

@keyframes spinner-line-fade-quick {
	0%,
	39%,
	100% {
		opacity: 0.25; /* minimum opacity */
	}
	40% {
		opacity: 1;
	}
}

@keyframes spinner-line-fade-default {
	0%,
	100% {
		opacity: 0.22; /* minimum opacity */
	}
	1% {
		opacity: 1;
	}
}
</style>

